import { render, staticRenderFns } from "./EarTag.vue?vue&type=template&id=516efd26&scoped=true&"
import script from "./EarTag.vue?vue&type=script&lang=ts&"
export * from "./EarTag.vue?vue&type=script&lang=ts&"
import style0 from "./EarTag.vue?vue&type=style&index=0&id=516efd26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516efd26",
  null
  
)

export default component.exports